import { flow, types, getEnv } from 'mobx-state-tree'

import { Athlete } from './'

const Athletes = types
  .model('AthletesModel', {
    items: types.optional(types.map(Athlete), {}),
  })
  .actions((self) => {
    const {
      services: { athleteService },
    } = getEnv(self)

    return {
      loadOne: flow(function* (id) {
        if (!self.items.has(id)) {
          const athlete = yield athleteService.get(id)
          self.items.set(id, athlete)
        }

        return self.items.get(id)
      }),

      load: flow(function* (params) {
        const response = yield athleteService.query(params)

        const athletes = response.content.map((athlete) => {
          self.items.set(athlete.id, athlete)
          return self.items.get(athlete.id)
        })

        return {
          response,
          athletes,
        }
      }),
    }
  })

export const AthletesRoot = types.model('AthleteRoot', {
  athletes: types.optional(Athletes, {}),
})
